import { useCallback } from "react";

interface UseConfirmDialogOptions {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

export const useConfirmDialog = (options: UseConfirmDialogOptions = {}) => {
  const {
    message = "Are you sure you want to proceed?",
  } = options;

  const confirm = useCallback(
    (customMessage?: string): Promise<boolean> => {
      return new Promise((resolve) => {
        const result = window.confirm(customMessage || message);
        resolve(result);
      });
    },
    [message]
  );

  const confirmUnsavedChanges = useCallback((): Promise<boolean> => {
    return confirm("You have unsaved changes. Are you sure you want to close?");
  }, [confirm]);

  const confirmDelete = useCallback(
    (itemName?: string): Promise<boolean> => {
      const deleteMessage = itemName
        ? `Are you sure you want to delete "${itemName}"? This action cannot be undone.`
        : "Are you sure you want to delete this item? This action cannot be undone.";
      return confirm(deleteMessage);
    },
    [confirm]
  );

  const confirmLeave = useCallback((): Promise<boolean> => {
    return confirm("You have unsaved changes. Are you sure you want to leave?");
  }, [confirm]);

  return {
    confirm,
    confirmUnsavedChanges,
    confirmDelete,
    confirmLeave,
  };
};
